import { decodeHtml } from './decoder';

export const getDisplayCoin = (ticker: string | undefined, coin: string | undefined): string => {
    if (!coin) return '';
    if (!ticker || ticker === '') return coin;
    return decodeHtml(ticker);
};
